const AudioContext = window['AudioContext'] || window['webkitAudioContext'];
let audioContext: AudioContext;

if (AudioContext) {
  audioContext = new AudioContext();
}

export class WebAudioFactory {

  getAudioContext(): AudioContext {
    return audioContext;
  }

}



// WEBPACK FOOTER //
// ./src/app/rec/factories/web-audio.factory.ts